import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: '#876DEE'
            },
            dark: false,
        }
    },
    icons: {
        iconfont: 'mdi',
    }
});

// Extending Vuetify
Object.defineProperty(Vue.prototype, '$snackbar', {
    value: function(text, type = null, options = {}) {
        Vue.prototype.$eventBus.$emit('show-snackbar', text, type, options);
    }
});

Object.defineProperty(Vue.prototype, '$snackbarHide', {
    value: function() {
        Vue.prototype.$eventBus.$emit('hide-snackbar');
    }
});

Object.defineProperty(Vue.prototype, '$confirm', {
    value: function(message, options = {}, callback = () => {}) {
        Vue.prototype.$eventBus.$emit('show-confirm', message, options, callback);
    }
});
